import { ref as v, watch as i, computed as y, provide as w, inject as g } from "vue";
function o(e) {
  if (e) return e;
  if (!(typeof window > "u"))
    return window.localStorage;
}
function L(e) {
  const a = e.parse ?? ((r) => JSON.parse(r)), u = e.stringify ?? ((r) => JSON.stringify(r));
  return {
    read() {
      try {
        const t = o(e.storage)?.getItem(e.key);
        return t ? a(t) : null;
      } catch (r) {
        return e.onError?.(r, "read"), null;
      }
    },
    write(r) {
      try {
        o(e.storage)?.setItem(e.key, u(r));
      } catch (t) {
        e.onError?.(t, "write");
      }
    },
    remove() {
      try {
        o(e.storage)?.removeItem(e.key);
      } catch (r) {
        e.onError?.(r, "remove");
      }
    }
  };
}
function E(e) {
  return {
    currentLanguage: e.currentLanguage,
    availableLanguages: e.availableLanguages,
    setLanguage(a) {
      if (!e.availableLanguages.includes(a))
        throw new Error(`Unsupported locale: ${a}`);
      e.setLanguage(a);
    }
  };
}
function C(e) {
  return typeof structuredClone == "function" ? structuredClone(e) : JSON.parse(JSON.stringify(e));
}
function S(e) {
  const a = e.clone ?? C, r = v((() => {
    if (!e.storage) return a(e.defaults);
    try {
      const t = e.storage.read();
      return t ? e.migrate ? e.migrate(t, e.defaults) : { ...a(e.defaults), ...t } : a(e.defaults);
    } catch (t) {
      return e.onError?.(t, "read"), a(e.defaults);
    }
  })());
  return i(
    r,
    (t) => {
      try {
        e.storage?.write(t);
      } catch (c) {
        e.onError?.(c, "write");
      }
    },
    { deep: !0 }
  ), {
    settings: r,
    reset() {
      r.value = a(e.defaults);
      try {
        e.storage?.remove?.();
      } catch (t) {
        e.onError?.(t, "remove");
      }
    },
    patch(t) {
      r.value = { ...r.value, ...t };
    },
    set(t, c) {
      r.value = { ...r.value, [t]: c };
    }
  };
}
function k(e) {
  const a = e.darkClass ?? "dark", u = e.colorThemeClassPrefix ?? "theme-", r = e.systemDarkQuery ?? "(prefers-color-scheme: dark)", t = e.target ?? (typeof document > "u" ? void 0 : document), c = typeof window > "u" ? void 0 : window.matchMedia(r), d = y(() => e.theme.value === "system" ? !!c?.matches : e.theme.value === "dark"), l = () => {
    const n = t?.documentElement;
    if (n && (n.classList.toggle(a, d.value), e.colorTheme && e.colorThemes?.length)) {
      for (const h of e.colorThemes)
        n.classList.remove(`${u}${h}`);
      const f = e.colorTheme.value;
      (!e.defaultColorTheme || f !== e.defaultColorTheme) && n.classList.add(`${u}${f}`);
    }
  }, m = () => {
    e.theme.value === "system" && l();
  };
  return c?.addEventListener("change", m), {
    theme: e.theme,
    colorTheme: e.colorTheme,
    isDark: d,
    setTheme(n) {
      e.theme.value = n, l();
    },
    setColorTheme(n) {
      e.colorTheme && (e.colorTheme.value = n, l());
    },
    apply: l,
    stop() {
      c?.removeEventListener("change", m);
    }
  };
}
const s = /* @__PURE__ */ Symbol("LunaAppCore");
function A(e) {
  return w(s, e), e;
}
function I() {
  const e = g(s);
  if (!e)
    throw new Error("App core context has not been provided");
  return e;
}
function b() {
  return g(s);
}
export {
  L as createJsonStorageAdapter,
  E as createLanguageController,
  S as createSettingsStore,
  k as createThemeController,
  A as provideAppCore,
  b as tryUseAppCore,
  I as useAppCore
};
